import Vue from 'vue';
import storage from 'store';
import ElementUI from 'element-ui';
import App from './app.vue';
import router from './router';
import store from './store';
import http from './http';
import utils from './utils';
import './components';
import './mixins';
import './scss/element.scss';
import './scss/global.scss';
import 'jquery';
import soundManager from 'soundmanager2';
Vue.config.productionTip = false;
Vue.prototype.$storage = storage;
Vue.prototype.$http = http;
Vue.prototype.$utils = utils;
Vue.prototype.$soundManager = soundManager.soundManager;
Vue.use(ElementUI);
Vue.prototype.$soundManager.setup({
  onready: () => {},
  waitForWindowLoad: true,
});
if (utils.env() === 'production') {
  console.log = function() {};
}
new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
